<div class="table-responsive animated fadeIn slow">

    <div>
        <h2 class="titulo text-center">REPORTES DE APOYO PARA LENTES</h2>
    </div>

    <!-- FILTROS -->
    <div class="filtros-wrapper">

        <div class="filtro">
            <label>Tipo de reporte</label>
            <select class="input-clean" [(ngModel)]="tipoReporte">
                <option value="nopagado">No pagado</option>
                <option value="pagado">Pagado</option>
                <option value="todos">Todos</option>
            </select>
        </div>

        <div class="filtro">
            <label>Fecha inicio</label>
            <input type="date" class="input-clean" [(ngModel)]="fechaInicio">
        </div>

        <div class="filtro">
            <label>Fecha fin</label>
            <input type="date" class="input-clean" [(ngModel)]="fechaFin">
        </div>

        <div class="filtro filtro-boton">
            <button class="btn-accent" (click)="buscarReportes()">
                <i class="fas fa-search"></i> Buscar
            </button>
        </div>

    </div>

    <!-- BOTÓN EXCEL -->
    <div class="excel-wrapper">
        <button class="btn-excel" (click)="exportarExcel()">
            <i class="fas fa-file-excel"></i> Exportar Excel
        </button>
    </div>

    <!-- RESULTADOS -->
    <div class="table-responsive mt-4" *ngIf="resultados.length > 0">

        <div class="resultados-count text-center">
            {{ resultados.length }} resultados encontrados
        </div>

        <table class="tabla-asignaturas">
            <thead>
                <tr>
                    <th>Categoría</th>
                    <th>Empleado</th>
                    <th>Folio SAT</th>
                    <th>Importe</th>
                    <th>No. Factura</th>
                    <th>Fecha Factura</th>
                    <th>Receta</th>
                    <th>Emisor</th>
                    <th>Observación</th>
                    <th>No. Oficio</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let b of resultados">
                    <td>{{ b.categoria }}</td>
                    <td>{{ b["nombre empleado"] }}</td>
                    <td>{{ b["folio SAT"] }}</td>
                    <td>{{ b.importe }}</td>
                    <td>{{ b["no. factura"] }}</td>
                    <td>{{ b.fecha_factura | date:'dd/MM/yyyy' }}</td>
                    <td>{{ b.fecha_receta | date:'dd/MM/yyyy' }}</td>
                    <td>{{ b.emisor }}</td>
                    <td>{{ b["observación"] }}</td>
                    <td>{{ b.no_oficio }}</td>
                </tr>
            </tbody>
        </table>
    </div>

</div>